<template>
  <div class="w-full h-screen flex flex-col justify-center items-center space-y-10">
      <ConfirmIcon/>
      <h2 class=" font-semibold text-4xl">Post Confirmed</h2>
      <div class="flex w-4/12 space-x-2">
        <inertia-link :href="$route('scheduler.posts.index')"  class="w-6/12 h-11 flex justify-center items-center bg-payneMild  text-white font-medium rounded-md" >
        <div
          @mouseover="overButton(true)"
          @mouseleave="overButton(false)">
          <vue-loading v-if="loading" type="bubbles" color="#FFFFFF" :size="{ width: '30px', height: '30px' }"></vue-loading>
          <span v-else class=" font-light text-white">Return to All Media</span>
        </div>
      </inertia-link>
      <inertia-link :href="$route('scheduler.posts.create')" class="w-6/12 h-11 flex items-center justify-center bg-aquamarine  text-white font-medium rounded-md" >
        <div
          class="flex justify-center items-center"
          @mouseover="overButton(true)"
          @mouseleave="overButton(false)">
          <vue-loading v-if="loading" type="bubbles" color="#FFFFFF" :size="{ width: '30px', height: '30px' }"></vue-loading>
          <span v-else class=" font-light text-white mr-2">Post more media</span>
          <BackArrow class="transform rotate-180" color="#FFFFFF"/>
        </div>
      </inertia-link>
      </div>
  </div>
</template>

<script>
import ConfirmIcon from '@/components/svg/ConfirmIcon';
import BackArrow from '@/components/svg/BackArrow';
export default {
name:"postConfirm",
components: {
    ConfirmIcon,
    BackArrow
},
}
</script>